import { Avatar, Stack, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { BOX_SHADOWS, TEXT_ELLIPSIS } from "../../../Shared/styles";

export const PollOptionStack = styled(Stack, {
    shouldForwardProp: (prop) =>
        prop !== "backgroundColorPercentage" &&
        prop !== "pollIsActive" &&
        prop !== "userVoted",
})<{
    pollIsActive: boolean;
    userVoted: boolean;
    backgroundColorPercentage?: number;
}>(({ backgroundColorPercentage = 0, pollIsActive, userVoted }) => ({
    borderRadius: "8px",
    border: "1px solid var(--community-color-dark-gray)",
    gap: "8px",
    alignItems: "center",
    overflow: "hidden",
    padding: "4px 8px",
    height: "unset",
    minHeight: "36px",
    cursor: pollIsActive ? "pointer" : "default",
    background: `linear-gradient(to right, #aca5db ${backgroundColorPercentage}%, transparent ${backgroundColorPercentage}%)`,
}));

export const ResponderAvatar = styled(Avatar)({
    backgroundColor: "var(--community-color-snow-white)",
    width: "24px",
    height: "24px",
    boxShadow: BOX_SHADOWS.ELEVATION_1,
});

export const PollDetailsStack = styled(Stack)({
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
});

export const ImagePollOptionContainerStack = styled(Stack)({
    flexDirection: "row",
    gap: "4px",
    flexWrap: "wrap",
    width: "auto",
    flex: "1",
});

export const ImagePollOptionStack = styled(Stack, {
    shouldForwardProp: (prop) => prop !== "pollIsActive" && prop !== "image",
})<{
    image: string;
    pollIsActive: boolean;
}>(({ pollIsActive, image }) => ({
    border: "1px solid var(--community-color-dark-gray)",
    gap: "8px",
    alignItems: "end",
    overflow: "hidden",
    padding: "8px",
    height: "100%",
    cursor: pollIsActive ? "pointer" : "default",
    backgroundImage: `url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    position: "relative",
    borderRadius: "8px",
}));

export const PollImageDetailsStack = styled(Stack)({
    backgroundColor: "rgba(255, 255, 255, .85)",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "4px",
    padding: "4px",
    width: "100%",
    fontSize: "14px",
    fontWeight: "400",
    color: "var(--community-color-primary-color)",
});

export const VotesPercentageTypography = styled(Typography)({
    flex: 1,
    fontSize: "14px",
    fontWeight: "700",
    color: "#50739d",
    ...TEXT_ELLIPSIS,
});
